import React, { useState } from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import classNames from 'classnames';
import axios from 'axios';

import HeroIcons from 'Global/Hero/HeroIcons/HeroIcons';

import css from './Hero.module.scss';

const Hero = ({ iconsData }) => {
	const [{ phone, phoneValid }, setPhone] = useState({});
	const [{ ctaButtonText, ctaButtonDisabled }, setCtaButton] = useState({
		ctaButtonText: 'Get Started',
		ctaButtonDisabled: false,
	});
	const [apiError, setApiError] = useState(false);
	const [submittedOnce, setSubmittedOnce] = useState(false);

	const isPhoneValid = e => {
		setApiError(false);
		const enteredPhone = e.target.value;

		if (/^[6-9]\d{9}$/.test(enteredPhone)) {
			setPhone({ phone: enteredPhone, phoneValid: true });

			return true;
		}
		setPhone({ phone: undefined, phoneValid: false });
		return false;
	};

	const handleSubmit = e => {
		setSubmittedOnce(true);
		e.preventDefault();

		//  phone is valid
		if (phone) {
			setCtaButton({ ctaButtonText: 'Submitting...', ctaButtonDisabled: true });
			axios
				.post('https://moneyfront-email.herokuapp.com/', {
					// TODO: change this
					phone,
					pageUrl: window.location.href,
				})
				.then(res => {
					window.location = '/thank-you';
				})
				.catch(err => {
					setCtaButton({
						ctaButtonText: 'Get Started',
						ctaButtonDisabled: false,
					});
					setApiError(true);
				});
		}

		// // email is invalid
		// return true;
	};

	const images = useStaticQuery(IMAGES_QUERY);
	return (
		<section className={classNames(css.hero, 'fontWhite')}>
			<div>
				<h1>Simplify all your financial decisions with one trusted advisor</h1>
				<div className={css.heroIcons}>
					{iconsData.map(({ id, src, alt, multipleText, text }) => (
						<HeroIcons
							key={id}
							src={src}
							alt={alt}
							multipleText={multipleText}
							text={text}
						/>
					))}
				</div>
				<div className={css.cta}>
					<form
						onSubmit={e => handleSubmit(e)}
						method="post"
						className={css.getStarted}
					>
						<input
							type="text"
							id="phone"
							name="phone"
							onChange={e => isPhoneValid(e)}
							placeholder="Enter your phone number"
							required
						/>
						<button className={css.formItem} disabled={ctaButtonDisabled}>
							{ctaButtonText}
						</button>
					</form>
					<div className={css.loginLink}>
						<Link to="#" className="linkUnderline">
							Login
						</Link>
					</div>
				</div>
				<div className={classNames(css.apiError, apiError && css.show)}>
					Something went wrong! Please try again later.
				</div>
				<span
					className={classNames(
						css.error,
						submittedOnce && phoneValid === false && css.errorPhone
					)}
				>
					Please enter a valid phone number
				</span>
			</div>
			<div className={css.heroImageWrapper}>
				<Img
					fluid={images.mockup.childImageSharp.fluid}
					alt="moneyfront app"
					className={css.heroImage}
					fadeIn={false}
					loading="eager"
				/>
			</div>
		</section>
	);
};

const IMAGES_QUERY = graphql`
	{
		mockup: file(relativePath: { eq: "home/desktop-mockup.png" }) {
			childImageSharp {
				fluid {
					...GatsbyImageSharpFluid_withWebp_noBase64
				}
			}
		}
	}
`;

export default Hero;
